import { MeetingsStore } from './meetings.store';
import { PageVisibilityService } from './page-visibility.service';

export class SyncActiveMeetingBetweenTabsService {
    static readonly LOCALSTORAGE_KEY = 'chat_active_meeting';
    static $inject = ['PageVisibilityService', 'MeetingsStore'];

    private heartbeatHandle: number | null = null;

    constructor(private pageVisibilityService: PageVisibilityService, private meetingsStore: MeetingsStore) {
        this.pageVisibilityService.isVisible$
            .combineLatest(this.meetingsStore.activeMeeting$.map((m) => m?.id))
            .subscribe(([visible, activeMeetingId]) => {
                // if visible:
                // update the active meeting
                // create interval that updates it
                if (visible) {
                    this.startHeartbeat(activeMeetingId as number);
                    return;
                }

                // if not visible
                // clear interval && clear the active meeting
                this.stopHeartbeat();
            });
    }

    getActiveMeetingId(): number | null {
        const item = localStorage.getItem(SyncActiveMeetingBetweenTabsService.LOCALSTORAGE_KEY) || '';

        try {
            const { activeMeetingId, timestamp } = JSON.parse(item);

            // discard the active meeting if it is out of date
            if (timestamp + 5000 < Date.now()) {
                return null;
            }

            return activeMeetingId;
        } catch (e) {
            console.warn(e);
        }

        return null;
    }

    private startHeartbeat(activeMeetingId: number) {
        this.heartbeatHandle && clearInterval(this.heartbeatHandle);
        this.storeActiveMeeting(activeMeetingId);
        this.heartbeatHandle = setInterval(() => this.storeActiveMeeting(activeMeetingId), 1000) as any;
    }

    private stopHeartbeat() {
        this.heartbeatHandle && clearInterval(this.heartbeatHandle);
        this.heartbeatHandle = null;
        this.storeActiveMeeting(null);
    }

    private storeActiveMeeting(activeMeetingId: number | null) {
        localStorage.setItem(
            SyncActiveMeetingBetweenTabsService.LOCALSTORAGE_KEY,
            JSON.stringify({ activeMeetingId, timestamp: Date.now() })
        );
    }
}

angular.module('tradersyard').service('SyncActiveMeetingBetweenTabsService', SyncActiveMeetingBetweenTabsService);
